// extracted by mini-css-extract-plugin
module.exports = {"root":"TabletMembers_root__2U-Vi","member":"TabletMembers_member__2TuKp","name":"TabletMembers_name__xVq-Q"};